import { render, staticRenderFns } from "./analysisrightsContent.vue?vue&type=template&id=28cd1362"
import script from "./analysisrightsContent.vue?vue&type=script&lang=js"
export * from "./analysisrightsContent.vue?vue&type=script&lang=js"
import style0 from "./analysisrightsContent.vue?vue&type=style&index=0&id=28cd1362&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports